<template>
  <div class="page flex-col">
    <div class="box_1 flex-row">
      <img
        class="label_1"
        referrerpolicy="no-referrer"
        src="./assets/img/FigmaDDSSlicePNGe909db0921cf6fdf268e6d7557656c70.png"
      />
      <span class="text_1">虹猫AI</span>
    </div>
    <div class="group_29 flex-col">
      <div class="block_8 flex-row">
        <div class="image-text_22 flex-col justify-between">
          <img
            class="image_1"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG38fdf2f0c3e1f12e9ba673d6cf4e413d.png"
          />
          <span class="text-group_1">卡通人物</span>
        </div>
      </div>
      <div class="block_9 flex-row">
        <div class="box_5 flex-row">
          <div class="image-text_23 flex-row justify-between">
            <img
              class="thumbnail_1"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNG3f77516085858d2a556846ce828353c7.png"
            />
            <span class="text-group_2">搜索</span>
          </div>
        </div>
        <div class="box_6 flex-col"></div>
        <div class="box_7 flex-col"></div>
      </div>
      <div class="block_10 flex-row">
        <div class="group_1 flex-col">
          <div class="group_2 flex-col"></div>
          <div class="text-group_33 flex-col justify-between">
            <span class="text_2">修仙老虎人</span>
            <div class="text-wrapper_1">
              <span class="text_3">2025-09-09&nbsp;·&nbsp;454</span>
              <span class="text_4">人围观</span>
            </div>
          </div>
          <div class="image-wrapper_1 flex-col">
            <img
              class="image_2"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNG3b8fc320c75fd396cb59d91fde258925.png"
            />
          </div>
        </div>
      </div>
      <div class="block_11 flex-row justify-between">
        <div class="section_1 flex-col">
          <div class="box_10 flex-col"></div>
          <div class="block_12 flex-row justify-between">
            <div class="text-group_34 flex-col justify-between">
              <span class="text_5">修仙老虎人</span>
              <div class="text-wrapper_2">
                <span class="text_6">2025-09-09&nbsp;·&nbsp;454</span>
                <span class="text_7">人围观</span>
              </div>
            </div>
            <div class="group_3 flex-row">
              <div class="image-text_24 flex-row justify-between">
                <img
                  class="thumbnail_2"
                  referrerpolicy="no-referrer"
                  src="./assets/img/FigmaDDSSlicePNG4de5248f0fc62ed28e777b8041704f3b.png"
                />
                <span class="text-group_5">同人合集</span>
              </div>
            </div>
          </div>
          <div class="image-wrapper_2 flex-col">
            <img
              class="image_3"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNG3b8fc320c75fd396cb59d91fde258925.png"
            />
          </div>
        </div>
        <div class="section_2 flex-col">
          <div class="section_3 flex-col"></div>
          <div class="box_36 flex-row justify-between">
            <div class="text-group_35 flex-col justify-between">
              <span class="text_8">修仙老虎人</span>
              <div class="text-wrapper_3">
                <span class="text_9">2025-09-09&nbsp;·&nbsp;454</span>
                <span class="text_10">人围观</span>
              </div>
            </div>
            <div class="group_4 flex-row">
              <div class="image-text_25 flex-row justify-between">
                <img
                  class="thumbnail_3"
                  referrerpolicy="no-referrer"
                  src="./assets/img/FigmaDDSSlicePNG4de5248f0fc62ed28e777b8041704f3b.png"
                />
                <span class="text-group_7">同人合集</span>
              </div>
            </div>
          </div>
          <div class="image-wrapper_3 flex-col">
            <img
              class="image_4"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNGcf7b2e43cd8aa203edf244e44330f90e.png"
            />
          </div>
        </div>
        <div class="section_5 flex-col">
          <div class="group_5 flex-col"></div>
          <div class="block_13 flex-row justify-between">
            <div class="text-group_36 flex-col justify-between">
              <span class="text_11">修仙老虎人</span>
              <div class="text-wrapper_4">
                <span class="text_12">2025-09-09&nbsp;·&nbsp;454</span>
                <span class="text_13">人围观</span>
              </div>
            </div>
            <div class="group_7 flex-row">
              <div class="image-text_26 flex-row justify-between">
                <img
                  class="thumbnail_4"
                  referrerpolicy="no-referrer"
                  src="./assets/img/FigmaDDSSlicePNG4de5248f0fc62ed28e777b8041704f3b.png"
                />
                <span class="text-group_9">同人合集</span>
              </div>
            </div>
          </div>
          <div class="image-wrapper_4 flex-col">
            <img
              class="image_5"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNG1f78f60f538239217bceee4992a43930.png"
            />
          </div>
        </div>
        <div class="section_6 flex-col">
          <div class="section_7 flex-col"></div>
          <div class="group_30 flex-row justify-between">
            <div class="text-group_37 flex-col justify-between">
              <span class="text_14">修仙老虎人</span>
              <div class="text-wrapper_5">
                <span class="text_15">2025-09-09&nbsp;·&nbsp;454</span>
                <span class="text_16">人围观</span>
              </div>
            </div>
            <div class="box_12 flex-row">
              <div class="image-text_27 flex-row justify-between">
                <img
                  class="thumbnail_5"
                  referrerpolicy="no-referrer"
                  src="./assets/img/FigmaDDSSlicePNG4de5248f0fc62ed28e777b8041704f3b.png"
                />
                <span class="text-group_11">同人合集</span>
              </div>
            </div>
          </div>
          <div class="image-wrapper_5 flex-col">
            <img
              class="image_6"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNGaa8589e61455c39ae25842b490160b05.png"
            />
          </div>
        </div>
        <div class="section_9 flex-col">
          <div class="group_8 flex-col"></div>
          <div class="section_16 flex-row justify-between">
            <div class="text-group_38 flex-col justify-between">
              <span class="text_17">修仙老虎人</span>
              <div class="text-wrapper_6">
                <span class="text_18">2025-09-09&nbsp;·&nbsp;454</span>
                <span class="text_19">人围观</span>
              </div>
            </div>
            <div class="box_13 flex-row">
              <div class="image-text_28 flex-row justify-between">
                <img
                  class="thumbnail_6"
                  referrerpolicy="no-referrer"
                  src="./assets/img/FigmaDDSSlicePNG4de5248f0fc62ed28e777b8041704f3b.png"
                />
                <span class="text-group_13">同人合集</span>
              </div>
            </div>
          </div>
          <div class="image-wrapper_6 flex-col">
            <img
              class="image_7"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNGbfa779a3c18dde6e20dce37d73e6ddee.png"
            />
          </div>
        </div>
      </div>
      <div class="block_14 flex-row justify-between">
        <div class="box_15 flex-col">
          <div class="group_10 flex-col"></div>
          <div class="box_37 flex-row justify-between">
            <div class="text-group_39 flex-col justify-between">
              <span class="text_20">修仙老虎人</span>
              <div class="text-wrapper_7">
                <span class="text_21">2025-09-09&nbsp;·&nbsp;454</span>
                <span class="text_22">人围观</span>
              </div>
            </div>
            <div class="section_10 flex-row">
              <div class="image-text_29 flex-row justify-between">
                <img
                  class="thumbnail_7"
                  referrerpolicy="no-referrer"
                  src="./assets/img/FigmaDDSSlicePNG4de5248f0fc62ed28e777b8041704f3b.png"
                />
                <span class="text-group_15">同人合集</span>
              </div>
            </div>
          </div>
          <div class="group_12 flex-col">
            <div class="image-wrapper_7 flex-col">
              <img
                class="thumbnail_8"
                referrerpolicy="no-referrer"
                src="./assets/img/FigmaDDSSlicePNG7ac7c833b1ac15280ee0df46fbb4de1f.png"
              />
            </div>
            <img
              class="image_8"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNG3b8fc320c75fd396cb59d91fde258925.png"
            />
          </div>
        </div>
        <div class="box_16 flex-col">
          <div class="group_13 flex-col"></div>
          <div class="group_31 flex-row justify-between">
            <div class="text-group_40 flex-col justify-between">
              <span class="text_23">修仙老虎人</span>
              <div class="text-wrapper_8">
                <span class="text_24">2025-09-09&nbsp;·&nbsp;454</span>
                <span class="text_25">人围观</span>
              </div>
            </div>
            <div class="section_11 flex-row">
              <div class="image-text_30 flex-row justify-between">
                <img
                  class="thumbnail_9"
                  referrerpolicy="no-referrer"
                  src="./assets/img/FigmaDDSSlicePNG4de5248f0fc62ed28e777b8041704f3b.png"
                />
                <span class="text-group_17">同人合集</span>
              </div>
            </div>
          </div>
          <div class="group_15 flex-col">
            <div class="image-wrapper_8 flex-col">
              <img
                class="thumbnail_10"
                referrerpolicy="no-referrer"
                src="./assets/img/FigmaDDSSlicePNG7ac7c833b1ac15280ee0df46fbb4de1f.png"
              />
            </div>
            <img
              class="image_9"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNGcf7b2e43cd8aa203edf244e44330f90e.png"
            />
          </div>
        </div>
        <div class="box_17 flex-col">
          <div class="box_18 flex-col"></div>
          <div class="section_17 flex-row justify-between">
            <div class="text-group_41 flex-col justify-between">
              <span class="text_26">修仙老虎人</span>
              <div class="text-wrapper_9">
                <span class="text_27">2025-09-09&nbsp;·&nbsp;454</span>
                <span class="text_28">人围观</span>
              </div>
            </div>
            <div class="box_20 flex-row">
              <div class="image-text_31 flex-row justify-between">
                <img
                  class="thumbnail_11"
                  referrerpolicy="no-referrer"
                  src="./assets/img/FigmaDDSSlicePNG4de5248f0fc62ed28e777b8041704f3b.png"
                />
                <span class="text-group_19">同人合集</span>
              </div>
            </div>
          </div>
          <div class="box_21 flex-col">
            <div class="image-wrapper_9 flex-col">
              <img
                class="thumbnail_12"
                referrerpolicy="no-referrer"
                src="./assets/img/FigmaDDSSlicePNG7ac7c833b1ac15280ee0df46fbb4de1f.png"
              />
            </div>
            <img
              class="image_10"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNG1f78f60f538239217bceee4992a43930.png"
            />
          </div>
        </div>
        <div class="box_22 flex-col">
          <div class="block_1 flex-col"></div>
          <div class="box_38 flex-row justify-between">
            <div class="text-group_42 flex-col justify-between">
              <span class="text_29">修仙老虎人</span>
              <div class="text-wrapper_10">
                <span class="text_30">2025-09-09&nbsp;·&nbsp;454</span>
                <span class="text_31">人围观</span>
              </div>
            </div>
            <div class="group_16 flex-row">
              <div class="image-text_32 flex-row justify-between">
                <img
                  class="thumbnail_13"
                  referrerpolicy="no-referrer"
                  src="./assets/img/FigmaDDSSlicePNG4de5248f0fc62ed28e777b8041704f3b.png"
                />
                <span class="text-group_21">同人合集</span>
              </div>
            </div>
          </div>
          <div class="block_3 flex-col">
            <div class="image-wrapper_10 flex-col">
              <img
                class="thumbnail_14"
                referrerpolicy="no-referrer"
                src="./assets/img/FigmaDDSSlicePNG7ac7c833b1ac15280ee0df46fbb4de1f.png"
              />
            </div>
            <img
              class="image_11"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNGaa8589e61455c39ae25842b490160b05.png"
            />
          </div>
        </div>
        <div class="box_23 flex-col">
          <div class="block_4 flex-col"></div>
          <div class="group_32 flex-row justify-between">
            <div class="text-group_43 flex-col justify-between">
              <span class="text_32">修仙老虎人</span>
              <div class="text-wrapper_11">
                <span class="text_33">2025-09-09&nbsp;·&nbsp;454</span>
                <span class="text_34">人围观</span>
              </div>
            </div>
            <div class="group_17 flex-row">
              <div class="image-text_33 flex-row justify-between">
                <img
                  class="thumbnail_15"
                  referrerpolicy="no-referrer"
                  src="./assets/img/FigmaDDSSlicePNG4de5248f0fc62ed28e777b8041704f3b.png"
                />
                <span class="text-group_23">同人合集</span>
              </div>
            </div>
          </div>
          <div class="block_6 flex-col">
            <div class="image-wrapper_11 flex-col">
              <img
                class="thumbnail_16"
                referrerpolicy="no-referrer"
                src="./assets/img/FigmaDDSSlicePNG7ac7c833b1ac15280ee0df46fbb4de1f.png"
              />
            </div>
            <img
              class="image_12"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNGbfa779a3c18dde6e20dce37d73e6ddee.png"
            />
          </div>
        </div>
      </div>
      <div class="block_15 flex-row">
        <div class="image-wrapper_12 flex-col">
          <img
            class="thumbnail_17"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG7fe40065ccf2408d5e4647cc4a80b33b.png"
          />
        </div>
        <div class="text-wrapper_12 flex-col"><span class="text_35">1</span></div>
        <div class="text-wrapper_13 flex-col"><span class="text_36">2</span></div>
        <div class="text-wrapper_14 flex-col"><span class="text_37">3</span></div>
        <div class="text-wrapper_15 flex-col"><span class="text_38">...</span></div>
        <div class="text-wrapper_16 flex-col"><span class="text_39">100</span></div>
        <div class="image-wrapper_13 flex-col">
          <img
            class="thumbnail_18"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNGcfd320f94e053899428644921e4ff0dd.png"
          />
        </div>
      </div>
      <div class="text-wrapper_22 flex-row">
        <span class="text_40">
          Copyright&nbsp;2025&nbsp;虹猫AI技术有限公司.&nbsp;All&nbsp;Rights&nbsp;Reserved&nbsp;浙ICP备xxxxx号
        </span>
      </div>
      <div class="box_25 flex-col"></div>
      <div class="box_26 flex-col"></div>
      <div class="box_27 flex-col">
        <div class="text-wrapper_18 flex-col"><span class="text_41">登录</span></div>
        <div class="section_12 flex-row justify-between">
          <div class="box_39 flex-col">
            <span class="text_42">虹猫&nbsp;素材网</span>
            <img
              class="image_13"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNGfed3ea6f378441db0fbb23d39ee7c0a1.png"
            />
            <span class="text_43">下载的不止是素材，是故事的开始！</span>
          </div>
          <img
            class="image_14"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG6fcc2a468bc54aa0a3d966eddbfce04d.png"
          />
        </div>
      </div>
    </div>
    <div class="box_28 flex-col">
      <div class="block_16 flex-row justify-between">
        <div class="group_18 flex-row justify-between">
          <span class="text_44">用户登录</span>
          <img
            class="thumbnail_19"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG43a192be4d9b4570482b039f83624438.png"
          />
        </div>
        <div class="group_19 flex-row justify-between">
          <span class="text_45">用户登录</span>
          <img
            class="thumbnail_20"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG43a192be4d9b4570482b039f83624438.png"
          />
        </div>
      </div>
      <div class="block_17 flex-row justify-between">
        <div class="box_31 flex-col">
          <span class="text_46">登录账号</span>
          <div class="section_13 flex-row">
            <div class="image-text_34 flex-row justify-between">
              <img
                class="thumbnail_21"
                referrerpolicy="no-referrer"
                src="./assets/img/FigmaDDSSlicePNGe7f1357da7ca3de5eb55242311ae5061.png"
              />
              <span class="text-group_24">请输入</span>
            </div>
          </div>
          <span class="text_47">登录密码</span>
          <div class="image-wrapper_14 flex-row">
            <img
              class="thumbnail_22"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNG2625bff46575ad5e653f1d532bc3e3f9.png"
            />
            <img
              class="image_15"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNGa268041c556a21ce0442451f2bf06afa.png"
            />
            <img
              class="thumbnail_23"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNG500348604ab39c239a78b7812025068f.png"
            />
          </div>
          <span class="text_48">验证码</span>
          <div class="group_33 flex-row justify-between">
            <div class="section_15 flex-row">
              <div class="image-text_35 flex-row justify-between">
                <img
                  class="thumbnail_24"
                  referrerpolicy="no-referrer"
                  src="./assets/img/FigmaDDSSlicePNG0ad8dccd00dd9328aacfe59f951b690f.png"
                />
                <span class="text-group_25">4974</span>
              </div>
            </div>
            <img
              class="image_16"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNGb6a0965efa92e62207e3257893233066.png"
            />
          </div>
          <div class="text-wrapper_19 flex-col"><span class="text_49">登录</span></div>
        </div>
        <div class="box_32 flex-col">
          <span class="text_50">登录账号</span>
          <div class="group_20 flex-row">
            <div class="image-text_36 flex-row justify-between">
              <img
                class="thumbnail_25"
                referrerpolicy="no-referrer"
                src="./assets/img/FigmaDDSSlicePNGe7f1357da7ca3de5eb55242311ae5061.png"
              />
              <span class="text-group_26">请输入</span>
            </div>
          </div>
          <div class="block_18 flex-row justify-between">
            <img
              class="thumbnail_26"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNGf178ee06339c21d7126c55bc0d4a24fd.png"
            />
            <span class="text_51">报错解释</span>
          </div>
          <span class="text_52">登录密码</span>
          <div class="group_22 flex-row">
            <div class="image-text_37 flex-row justify-between">
              <img
                class="thumbnail_27"
                referrerpolicy="no-referrer"
                src="./assets/img/FigmaDDSSlicePNG2625bff46575ad5e653f1d532bc3e3f9.png"
              />
              <span class="text-group_27">497493873</span>
            </div>
            <img
              class="thumbnail_28"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNG6805008ab3b6c73f621ba409c21aac46.png"
            />
          </div>
          <span class="text_53">验证码</span>
          <div class="block_19 flex-row justify-between">
            <div class="group_24 flex-row">
              <div class="image-text_38 flex-row justify-between">
                <img
                  class="thumbnail_29"
                  referrerpolicy="no-referrer"
                  src="./assets/img/FigmaDDSSlicePNG0ad8dccd00dd9328aacfe59f951b690f.png"
                />
                <span class="text-group_28">4974</span>
              </div>
            </div>
            <img
              class="image_17"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNGb6a0965efa92e62207e3257893233066.png"
            />
          </div>
          <div class="text-wrapper_20 flex-col"><span class="text_54">登录</span></div>
        </div>
      </div>
      <div class="block_20 flex-row">
        <div class="box_34 flex-row justify-between">
          <span class="text_55">购买账号</span>
          <img
            class="thumbnail_30"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG43a192be4d9b4570482b039f83624438.png"
          />
        </div>
      </div>
      <div class="block_21 flex-row justify-between">
        <div class="group_25 flex-col">
          <span class="text_56">
            提示：请务必仔细填写自己运营的抖音账号信息，付费后网站素材只授权单个抖音账号(如需发布其他平台，请保持与授权的抖音账号昵称一致，后续如需更改账号信息，请联系客服更改，否则后期账号涉及版权法律责任后果自负，购买季度会员授权3个月，且素材每天下载次数为25次/天，购买年度会员授权1年，且素材每天下载次数为100次/天，季度会员没有单独定制个人专属素材权限。)，【注意:不允许以任何形式转卖素材网账号，一经发现一律停用】
          </span>
          <span class="text_57">购买会员类型：</span>
          <div class="box_40 flex-row justify-between">
            <div class="image-text_39 flex-row justify-between">
              <img
                class="thumbnail_31"
                referrerpolicy="no-referrer"
                src="./assets/img/FigmaDDSSlicePNGcbf7abb76e09ac2d6258a35f36c653d5.png"
              />
              <span class="text-group_29">年度会员</span>
            </div>
            <div class="image-text_40 flex-row justify-between">
              <img
                class="thumbnail_32"
                referrerpolicy="no-referrer"
                src="./assets/img/FigmaDDSSlicePNG6b71f8d3555fbf8458dcca3c78fc55ec.png"
              />
              <span class="text-group_30">季度会员</span>
            </div>
          </div>
          <span class="text_58">支付方式：</span>
          <div class="box_41 flex-row">
            <img
              class="thumbnail_33"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNGcbf7abb76e09ac2d6258a35f36c653d5.png"
            />
            <div class="image-text_41 flex-row justify-between">
              <img
                class="thumbnail_34"
                referrerpolicy="no-referrer"
                src="./assets/img/FigmaDDSSlicePNGf95d2e0125f8c2140877bac324322feb.png"
              />
              <span class="text-group_31">微信支付</span>
            </div>
            <img
              class="thumbnail_35"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNG6b71f8d3555fbf8458dcca3c78fc55ec.png"
            />
            <div class="image-text_42 flex-row justify-between">
              <img
                class="thumbnail_36"
                referrerpolicy="no-referrer"
                src="./assets/img/FigmaDDSSlicePNG9e1e436078be67877b834b243c7eb83e.png"
              />
              <span class="text-group_32">支付宝支付</span>
            </div>
          </div>
          <div class="text-wrapper_21 flex-col"><span class="text_59">登录</span></div>
        </div>
        <div class="group_28 flex-col"></div>
      </div>
      <img
        class="image_18"
        referrerpolicy="no-referrer"
        src="./assets/img/FigmaDDSSlicePNGbc1a91d8959a97d00235aca19ebe4162.png"
      />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />